var _path, _g, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.111 71.111H227.555v156.445H0V384c0 31.416 25.473 56.889 56.889 56.889H455.11C486.527 440.889 512 415.416 512 384V128c0-31.416-25.473-56.889-56.889-56.889z",
    fill: "#ed2939"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.736 317.441h88.747l-44.374-44.373-44.373 44.373zM435.485 199.111h-88.746l44.374 44.374 44.372-44.374zM450.275 302.649v-88.746l-44.374 44.373 44.374 44.373zM331.946 213.903v88.746l44.374-44.374-44.374-44.372z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.334 71.111H56.889C25.472 71.111 0 96.584 0 128v113.778h85.334V71.11z",
    fill: "#002395"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.334 71.111v170.666H0V256h270.222V71.111H85.334z",
    fill: "#eee"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 241.778h-85.334V71.11H256v170.666z",
    fill: "#ed2939"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.666 241.778H85.334V71.11h85.334v170.666z",
    fill: "#eee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWf);
export default __webpack_public_path__ + "static/media/wf.e6cad7adaf9935b7ac1e39a57e236758.svg";
export { ForwardRef as ReactComponent };